import React, { Component } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";

import { ARCHIVE_WEBAPP_URL } from "../../../config";
import PortaleChildApp from "../../portale-child-app";

class Archive extends Component {
    static propTypes = {
        auth: PropTypes.object
    };

    render() {
        return <PortaleChildApp url={ARCHIVE_WEBAPP_URL} hideElevioAndUservoice={false} />;
    }
}

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(mapStateToProps)(Archive);
